import { CalendarWeekOutlineIcon } from './CalendarWeekOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 9B0A106E-1157-40C2-9A68-97E1BA92A658
 * name calendar-week-outline
 * version: 6.7.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/calendar-week-outline.svg
 * tags
 * - Date / Time 
 */
export const EventWeekOutlineIcon = CalendarWeekOutlineIcon;
export default EventWeekOutlineIcon